import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";

import { DashboardRoutingModule } from "./dashboard-routing.module";
import { ChartistModule } from 'ng-chartist';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularResizedEventModule } from 'angular-resize-event';
import { MatchHeightModule } from "../shared/directives/match-height.directive";
import { NgxSpinnerModule } from 'ngx-spinner';
import { Dashboard1Component } from "./dashboard1/dashboard1.component";
import { Dashboard2Component } from "./dashboard2/dashboard2.component";
import { MatMenuModule } from '@angular/material/menu';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { PipeModule } from 'app/shared/pipes/pipe.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { PermissionGuard } from 'app/shared/auth/auth-guard.service';
import { LatestDashboardComponent } from './latest-dashboard/latest-dashboard.component';


@NgModule({
    imports: [
        CommonModule,
        DashboardRoutingModule,
        ChartistModule,
        NgbModule,
        MatchHeightModule,
        NgApexchartsModule,
        AngularResizedEventModule,
        NgxSpinnerModule,
        MatMenuModule,
        NgxDatatableModule,
        PipeModule,
        NgSelectModule,
        FormsModule,
    ],
    exports: [],
    declarations: [
        Dashboard1Component,
        Dashboard2Component,
        LatestDashboardComponent
    ],
    providers : [NgbActiveModal,PermissionGuard]
})
export class DashboardModule { }
